<template>
    <div class="android_setting_base">
        <span>端末のネットワークに関する設定を行ってください。</span>
        <!-- ネットワーク設定 -->
        <div class="android_setting_main">
            <ThreeStateToggle
                ref="chk_wifiConfigDisabledState"
                v-model="policyRef.policy.deviceConnectivityManagement!.configureWifi"
                :disabled="disabled" 
                id="chk_wifiConfigDisabled"
                :caption = "chk_wifiConfigDisabledCaption"
                :trueValue = "chk_wifiConfigDisabledTrueValue"
                :falseOptions = "chk_wifiConfigDisabledFalseOptions"
                @changeState="onChange"
                />

            <div class="scv-check-box d-flex align-items-center">
                <input type="checkbox"
                       id="chk_dataRoamingDisabled"
                       v-bind:disabled="disabled"
                       v-model="policyRef.policy.dataRoamingDisabled"
                       @change="onChange" />
                <label for="chk_dataRoamingDisabled" class="scv-check-label">ローミング中のデータサービス接続を禁止する</label>
            </div>

            <div class="scv-check-box d-flex align-items-center">
                <input type="checkbox"
                       id="chk_mobileNetworksConfigDisabled"
                       v-bind:disabled="disabled"
                       v-model="policyRef.policy.mobileNetworksConfigDisabled"
                       @change="onChange" />
                <label for="chk_mobileNetworksConfigDisabled" class="scv-check-label">モバイルネットワーク設定の変更を禁止する</label>
            </div>

            <div class="scv-check-box d-flex align-items-center">
                <input type="checkbox"
                       id="chk_vpnConfigDisabled"
                       v-bind:disabled="disabled"
                       v-model="policyRef.policy.vpnConfigDisabled"
                       @change="onChange" />
                <label for="chk_vpnConfigDisabled" class="scv-check-label">VPN設定の変更を禁止する</label>
            </div>

            <div class="sub-setting-table d-flex align-items-center">
                <div class="sub-category-font" style="margin-left: 8px;">接続するWi-Fiネットワーク</div>
            </div>
            <div class="android_setting_sub">
                <span>接続するWi-Fiネットワークを設定してください。</span>
                <div class="d-flex flex-column">
                    <ListTitleBar :titleCaption="'接続するWi-Fiネットワーク'"
                                  :btnCaption_1="'追加'"
                                  :btnCaption_2="'編集'"
                                  :btnCaption_3="'削除'"
                                  :btnActiveType_1="0"
                                  :btnActiveType_2="1"
                                  :btnActiveType_3="3"
                                  :rowCountArea="true"
                                  :rowCount="wifiNetworkSettings.length"
                                  @onBtnClicked_1="onBtnAddWifiNetwork"
                                  @onBtnClicked_2="onBtnEdtWifiNetwork"
                                  @onBtnClicked_3="onBtnDelWifiNetwork"
                                  :selectCount="getSelectCount()"
                                  :disabled="disabled">
                    </ListTitleBar>
                    <ListCtrl ref="wifiNetworkList"
                              :columns="wifiNetworkColumns"
                              :selectType="2"
                              :getCellTextFunc="getCellText"
                              style="min-height: 240px;"
                              :disabled="disabled">
                    </ListCtrl>
                </div>
            </div>
        </div>
    </div>

    <!-- 追加画面（接続するWi-Fiネットワークを設定してください）  -->
    <div class="modal fade" id="modalWifiNetwork" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-content-scv" style="position: relative; max-height: none; width: 700px;">
                <div class="modal-header modal-header-scv-cmn">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">{{modalCaption}}</span>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div class="android_modal_base">
                        <span>接続するWi-Fiネットワークを設定してください。</span>

                        <div class="android_modal_main">
                            <div class="d-flex flex-row" style="margin-left:38px">
                                <div class="box-item-title d-flex align-items-center" style="height:32px">
                                    <span>SSID：</span>
                                </div>
                                <div class="d-flex flex-column">
                                    <MaskInput convertType="text"
                                               class="input-text-scv condition-text"
                                               v-bind:class="{ 'input-validation-error': errorMessageEditSSID != '' }"
                                               v-bind:maxlength="def_settingSSIDMax"
                                               v-model="modalWifiNetworkSetting.ssid"
                                               id="ssidName"
                                               style="width: 500px"
                                               placeholder="<入力必須>"
                                               required />
                                    <div class="modal-body-input-error-area-scv">
                                        <div style="height: 4px"></div>
                                        <span class="scv-form-validation-error">{{ errorMessageEditSSID }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-row align-items-center" style="margin-left:74px; margin-bottom:24px;">
                                <span></span>
                                <div class="radio-select-area" style="width:380px">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <label class="scv-check-label-box">
                                                <input class="scv-check-label" type="radio" name="modalWifiNetwork_Security" v-model="modalWifiNetworkSetting.security" :value="0">
                                                <span>WPA／WPA2 PSK</span>
                                            </label>
                                        </div>
                                        <div class="android_setting_item_horizontal_margine">
                                            <div class="d-flex align-items-center">
                                                <label class="scv-check-label-box">
                                                    <input class="scv-check-label" type="radio" name="modalWifiNetwork_Security" v-model="modalWifiNetworkSetting.security" :value="1">
                                                    <span>WEP</span>
                                                </label>
                                                <InformationManual style="margin-left: 4px" :arMessage="['<div>パスワードには16進数のパスワードを設定してください。<br />文字列のパスワードは使用できません。</div>']" />
                                            </div>
                                        </div>
                                        <div class="android_setting_item_horizontal_margine">
                                            <label class="scv-check-label-box">
                                                <input class="scv-check-label" type="radio" name="modalWifiNetwork_Security" v-model="modalWifiNetworkSetting.security" :value="2">
                                                <span>なし</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-row" style="margin-left:0px">
                                <div class="box-item-title d-flex align-items-center" style="height:32px">
                                    <span>パスワード：</span>
                                </div>
                                <div class="d-flex flex-column">
                                    <MaskInput convertType="text"
                                               class="input-text-scv"
                                               v-bind:class="{ 'input-validation-error': errorMessageEditPassword != '' }"
                                               v-bind:maxlength="def_settingPasswordMax"
                                               v-model="modalWifiNetworkSetting.passphrase"
                                               style="width: 500px"
                                               type="password"
                                               :placeholder="getModalPassphrasePlaceHolder()"
                                               required />
                                    <div class="modal-body-input-error-area-scv">
                                        <div style="height: 4px"></div>
                                        <span class="scv-form-validation-error">{{ errorMessageEditPassword }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button type="button" class="btn-scv-blue" id="buttonApply_modalWifiNetwork" @click="onModalWifiNetworkOKButton" style="margin-right: 40px;">OK</button>
                            <button type="button" class="btn-scv-white" data-bs-dismiss="modal">キャンセル</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AndroidPolicyWrapper } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import { ListCtrl } from 'lib-vue-v2/components';
    import ListTitleBar from '@/components/ListTitleBar.vue';
    import { SearchColumnData, SearchColumnType } from '@/models/SearchColumnData';
    import MaskInput from '@/components/Input/MaskInput.vue';
    import { v4 as uuidv4 } from 'uuid';
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import InformationManual from '@/components/InformationManual.vue';
    import ThreeStateToggle from '@/views/Mobile/Android/ThreeStateToggle.vue';
    import * as schemaConstants from '@/models/Mobile/Android/AndroidManagementV1SchemaConstants'
    import { BootstrapUtil } from 'lib-vue-v2/util';

    // 
    class AndroidWifiSetting {
        guid = "";          // Wi-Fi設定の追加画面：GUID
        ssid = "";          // Wi-Fi設定の追加画面：SSID
        security = 0;       // Wi-Fi設定の追加画面：セキュリティ
        passphrase = "";    // Wi-Fi設定の追加画面：****
    }

    @Options({
        props: {
            disabled: { type: Boolean, Default: false },   /* 強制的にボタンをDisableにする*/
        },
        components: {
            ListCtrl,
            ListTitleBar,
            MaskInput,
            InformationManual,
            ThreeStateToggle
        },
        watch: {
            wifiNetworkSettings: {
                handler: function () {
                    /* eslint @typescript-eslint/no-explicit-any: 0 */
                    const refObj: any = this.$refs;
                    refObj.wifiNetworkList.updateList(this.wifiNetworkSettings.length);
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            }
        },
        emits: ['notifyUpdate'],
    })

    export default class AndroidNetworkSetting extends Vue {

        private policyRef = AndroidPolicyWrapper.convertDeprecatedPolicy(new AndroidPolicyWrapper());

        private readonly def_settingWifiMax = 99;
        private readonly def_settingSSIDMax = 32;
        private readonly def_settingPasswordMax = 64;

        private readonly wifiNetworkColumns: Array<SearchColumnData> =         // カラム
            [
                { columnID: 0, dataType: SearchColumnType.string, text: "SSID" },
                { columnID: 1, dataType: SearchColumnType.string, text: "セキュリティ" },
            ];

        private readonly securityWPAString = "WPA-PSK";
        private readonly securityWEPString = "WEP-PSK";
        private readonly securityNONEString = "None";

        private readonly securityWPAName = "WPA／WPA2 PSK";
        private readonly securityWEPName = "WEP";
        private readonly securityNONEName = "なし";

        private readonly chk_wifiConfigDisabledCaption = 'Wi-Fiネットワーク設定の変更を禁止する';
        private readonly chk_wifiConfigDisabledTrueValue = schemaConstants.AMAPI_ConfigureWifi_Enums.allowConfiguringWifi;
        private readonly chk_wifiConfigDisabledFalseOptions = [
            { 
                label: 'すべての設定の変更を禁止する',
                value: schemaConstants.AMAPI_ConfigureWifi_Enums.disallowConfiguringWifi, 
                information:undefined,
                change:undefined
            },
            {   label: '新しいWi-Fiネットワークの追加を禁止する（Android 13以降）',     
                value: schemaConstants.AMAPI_ConfigureWifi_Enums.disAllowAddWifiConfig, 
                information: "<div>Android 13未満の端末にはWi-Fiネットワーク設定の変更が許可されます。</div>",
                change: "Android 13未満の端末にはWi-Fiネットワーク設定の変更が許可されます。"
            }
        ];

        private wifiNetworkSettings = new Array<AndroidWifiSetting>();

        // モーダル用
        private modalAddMode = true;
        private modalCaption = "追加";
        private modalWifiNetworkSetting = new AndroidWifiSetting();
        private errorMessageEditSSID = "";
        private errorMessageEditPassword = "";

        /**
         *  UIのリセット
         */
        private resetUI() {
            this.wifiNetworkSettings = new Array<AndroidWifiSetting>();

            const refObj: any = this.$refs;
            refObj.chk_wifiConfigDisabledState?.resetSelectState();
        }

        /**
         *  ポリシーの参照をセット
         */
        public setPolicyRef(policy: AndroidPolicyWrapper): void {
            // 初期化
            this.resetUI();
            this.$nextTick(() => {
                this.policyRef = policy;

                if (undefined == this.policyRef.policy.openNetworkConfiguration) {
                    // これでアイテムを追加できる
                    this.policyRef.policy.openNetworkConfiguration = {
                        NetworkConfigurations: []
                    };

                    // データが無いなら空でいい
                    return;
                }
                else {
                    // policyからWifiのUIを設定する
                    this.updateWifiNetworkSettings();
                }
            });
        }

        /*
         * 選択状態の数を返します
         */
        private getSelectCount(): number {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // マウント前はundefinedの可能性があるのでundefinedチェックが必要
            if (undefined == refObj.wifiNetworkList) {
                return 0;
            }
            return refObj.wifiNetworkList.getSelectListIndex().length;
        }

        /**
        * リスト作成処理
        */
        private getCellText(columnId: number, index: number): string {

            if (this.wifiNetworkSettings.length <= index) {
                return "";
            }

            switch (columnId) {
                // SSID
                case 0:
                    return this.wifiNetworkSettings[index].ssid;

                // セキュリティ
                case 1:
                    return this.getSecurityTypeName(this.wifiNetworkSettings[index].security);
            }
            return "";
        }

        /**
         *  変更ハンドラ
         */
        public onChange(): void {
            this.$emit('notifyUpdate');
        }

        /**
         * @brief	追加ボタン
         */
        private onBtnAddWifiNetwork(): void {
            if (this.def_settingWifiMax <= this.wifiNetworkSettings.length) {
                let message = "これ以上登録することはできません。\r\n<br>接続するWi-Fiネットワークの登録上限は" + this.def_settingWifiMax.toString() + "件です。";
                MessageUtil.MessageBox(message, null, null, MessageUtil.MB_ICON_WARNING);
                return;
            }

            this.errorMessageEditSSID = "";
            this.errorMessageEditPassword = "";

            this.modalAddMode = true;
            this.modalCaption = "追加";
            this.modalWifiNetworkSetting = new AndroidWifiSetting();
            this.modalWifiNetworkSetting.guid = uuidv4();
            BootstrapUtil.showModal("modalWifiNetwork");
        }

        /**
         * @brief	編集ボタン
         */
        private onBtnEdtWifiNetwork(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.wifiNetworkList.getSelectListIndex();
            if (1 != indexs.length) {
                return;
            }

            this.errorMessageEditSSID = "";
            this.errorMessageEditPassword = "";

            // 編集データのセット
            this.modalAddMode = false;
            this.modalCaption = "編集";
            // オブジェクトを直接渡すと参照渡しになるので１つずつコピー
            this.modalWifiNetworkSetting = new AndroidWifiSetting();
            this.modalWifiNetworkSetting.guid = this.wifiNetworkSettings[indexs[0]].guid;
            this.modalWifiNetworkSetting.ssid = this.wifiNetworkSettings[indexs[0]].ssid;
            this.modalWifiNetworkSetting.security = this.wifiNetworkSettings[indexs[0]].security;
            this.modalWifiNetworkSetting.passphrase = this.wifiNetworkSettings[indexs[0]].passphrase;

            BootstrapUtil.showModal('modalWifiNetwork');
        }

        /**
         * @brief	削除ボタン
         */
        private onBtnDelWifiNetwork(): void {
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const selectedIndex = refObj.wifiNetworkList.getSelectListIndex();

            for (let i = selectedIndex.length; 0 < i; i--) {
                this.wifiNetworkSettings.splice(selectedIndex[i - 1], 1);
            }

            this.onChangeWifiNetworkSettings();
        }

        /**
         * @brief	OKボタン押下
         */
        public onModalWifiNetworkOKButton(): void {

            let error = false;

            // 文字列チェックを行います
            // 前後の空白をトリム
            let trimSsid = this.modalWifiNetworkSetting.ssid.trim();
            let trimPassphrase = this.modalWifiNetworkSetting.passphrase.trim();

            // SSID
            this.errorMessageEditSSID = "";
            if (trimSsid.length <= 0) {
                this.errorMessageEditSSID = "入力必須項目です。";
                error = true;
            }
            else {
                if (trimSsid.includeFullChar() ||
                    trimSsid.includeHalfCharKANA() ||
                    trimSsid.includeControlCode()) {
                    this.errorMessageEditSSID = "全角文字、半角カナ、制御コードは使用できません。";
                    error = true;
                }
            }

            // パスフレーズ（セキュリティがなしの場合はしない）
            this.errorMessageEditPassword = "";
            if (2 != this.modalWifiNetworkSetting.security) {
                if (trimPassphrase.length <= 0) {
                    this.errorMessageEditPassword = "入力必須項目です。";
                    error = true;
                }
                else {
                    if (trimPassphrase.includeFullChar() ||
                        trimPassphrase.includeHalfCharKANA() ||
                        trimPassphrase.includeControlCode()) {
                        this.errorMessageEditPassword = "全角文字、半角カナ、制御コードは使用できません。";
                        error = true;
                    }
                }
            }

            // エラーがあったら更新しない
            if (error) {
                return;
            }

            // トリムした値を代入
            this.modalWifiNetworkSetting.ssid = trimSsid;
            this.modalWifiNetworkSetting.passphrase = trimPassphrase;

            // 作業用の配列に確保
            if (this.modalAddMode) {
                this.wifiNetworkSettings.push(this.modalWifiNetworkSetting);
                this.onChangeWifiNetworkSettings();
                // 追加画面を閉じる
                BootstrapUtil.hideModal('modalWifiNetwork');
                return;
            }

            // 編集データを更新する
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            const indexs = refObj.wifiNetworkList.getSelectListIndex();

            this.wifiNetworkSettings[indexs[0]] = this.modalWifiNetworkSetting;
            this.onChangeWifiNetworkSettings();
            // 追加画面を閉じる
            BootstrapUtil.hideModal('modalWifiNetwork');
        }

        /**
         * @brief ポリシーのデータ更新
         */
        private onChangeWifiNetworkSettings(): void {

            // 初期化
            this.policyRef.policy.openNetworkConfiguration = {
                NetworkConfigurations: []
            };

            // Json用のデータを更新する
            let counter = 0;
            this.wifiNetworkSettings.forEach(x => {
                if (undefined != this.policyRef.policy.openNetworkConfiguration) {
                    // 自動接続する設定はONにする
                    // パスフレーズのないパターンとあるパターンで分岐
                    if (2 == x.security) {
                        this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[counter] =
                        {
                            GUID: x.guid,
                            Type: "WiFi",
                            Name: x.ssid,
                            WiFi: {
                                SSID: x.ssid,
                                Security: this.getSecurityTypeString(x.security),
                                AutoConnect: true
                            }
                        };
                    }
                    else {
                        this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[counter] =
                        {
                            GUID: x.guid,
                            Type: "WiFi",
                            Name: x.ssid,
                            WiFi: {
                                SSID: x.ssid,
                                Security: this.getSecurityTypeString(x.security),
                                Passphrase: x.passphrase,
                                AutoConnect: true
                            }
                        };
                    }
                }
                ++counter;
            });

            this.onChange();
        }

        /**
         * @brief ポリシーをもとにUIデータ更新
         */
        private updateWifiNetworkSettings(): void {
            if (undefined != this.policyRef.policy.openNetworkConfiguration) {
                for (let ii = 0; ii < this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations.length; ++ii) {
                    let data = new AndroidWifiSetting();
                    data.guid = this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[ii].GUID;
                    data.ssid = this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[ii].WiFi.SSID;
                    data.security = this.getSecurityType(this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[ii].WiFi.Security);
                    if (undefined != this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[ii].WiFi.Passphrase) {
                        data.passphrase = this.policyRef.policy.openNetworkConfiguration.NetworkConfigurations[ii].WiFi.Passphrase;
                    }
                    this.wifiNetworkSettings.push(data);
                }
            }
        }

        private getSecurityType(type: string): number {
            switch (type) {
                case this.securityWPAString:
                    return 0;
                case this.securityWEPString:
                    return 1;
                case this.securityNONEString:
                    return 2;
            }
            return 0;
        }
        private getSecurityTypeString(typeID: number): string {
            switch (typeID) {
                case 0:
                    return this.securityWPAString;
                case 1:
                    return this.securityWEPString;
                case 2:
                    return this.securityNONEString;
            }
            return "";
        }
        private getSecurityTypeName(typeID: number): string {
            switch (typeID) {
                case 0:
                    return this.securityWPAName;
                case 1:
                    return this.securityWEPName;
                case 2:
                    return this.securityNONEName;
            }
            return "";
        }

        /**
         * @brief パスフレーズのプレースホルダーテキスト
         */
        private getModalPassphrasePlaceHolder(): string {
            if (2 == this.modalWifiNetworkSetting.security) {
                return "";
            }
            return "<入力必須>";
        }
        
    }
</script>

<style>
    @import "../../../assets/css/setting.css";
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>